import { Button, FileInput, Group, Paper, Title } from "@mantine/core";
import type { ApiError } from "../../api";
import { useProfilePictureMutations } from "../../hooks/useProfilePictureMutation";
import { useToast } from "../../mantine/notifications/useToast";
import { getFieldSpecificError } from "../../utils/api-utils";

function ProfilePictureSettings() {
  const { showToast, showErrorToast } = useToast();
  const { editProfilePicture } = useProfilePictureMutations();

  const onSubmit = (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const selectedFile = formData.get("profileImage") as File;

    if (!selectedFile || selectedFile.size === 0) {
      showErrorToast("Bitte wählen Sie eine Datei aus");
      return;
    }

    editProfilePicture.mutate(selectedFile, {
      onSuccess: () => {
        showToast({
          type: "success",
          message: `Profil wurde erfolgreich geändert`
        });
      },
      onError: (error) => {
        const errorMessage = getFieldSpecificError(error as ApiError, [
          "image"
        ]);
        showErrorToast(errorMessage);
      }
    });
  };

  return (
    <Paper mb="lg">
      <Title variant="paper-header">Profil</Title>
      <form onSubmit={onSubmit}>
        <FileInput
          accept="image/png, image/jpg, image/jpeg"
          label="Profilbild"
          name="profileImage"
          placeholder="Datei auswählen"
          required
        />

        <Group variant="paper-footer">
          <Button
            color="secondary"
            loading={editProfilePicture.isPending}
            type="submit"
          >
            Speichern
          </Button>
        </Group>
      </form>
    </Paper>
  );
}

export { ProfilePictureSettings as ProfilePicture };
